/**
 * Admin write schemas for WebsitePartner (Phase 5 - CMS write API).
 *
 * `imageId` is REQUIRED on create - a partner without a logo can't render
 * on the partners section. `redirectTo` is the click-through URL; we don't
 * validate scheme here because some partners want internal /pages routes.
 */

import { z } from 'zod';

import { UuidSchema } from './common.js';

export const CreateWebsitePartnerRequestSchema = z.object({
  imageId: UuidSchema,
  redirectTo: z.string().min(1).max(2048),
  isExternal: z.boolean().default(false),
  name: z.string().max(120).nullish(),
  sortOrder: z.number().int().min(0).default(0),
});
export type CreateWebsitePartnerRequest = z.infer<typeof CreateWebsitePartnerRequestSchema>;

export const UpdateWebsitePartnerRequestSchema = CreateWebsitePartnerRequestSchema.partial();
export type UpdateWebsitePartnerRequest = z.infer<typeof UpdateWebsitePartnerRequestSchema>;
